import styled, { css } from 'styled-components';

import { Divider } from '@icarros/ids-react';
import { ids } from '@icarros/theme-react';

export const CardListActions = styled.div`
  @media (min-width: 766px) {
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;

    div {
      flex-direction: row;
      gap: 32px;

      > button + div {
        display: none;
      }

      > button {
        width: fit-content !important;
        margin-top: 0px;
        div:nth-of-type(3) {
          display: none;
          div {
            margin-left: 16px;
          }
          svg {
            display: none !important;
          }
        }
      }
    }

    > button {
      width: fit-content !important;
      min-width: 179px;
      justify-content: center !important;
      margin-top: 0 !important;
      align-self: center !important;

      svg {
        width: initial !important;
        height: initial !important;
      }
    }
  }
`;

export const CardOptionsWrapper = styled.div`
  @media (min-width: 766px) {
    position: relative;
  }
`;

export const CardButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  button {
    min-width: auto;
    width: 100%;
    justify-content: space-between;
    @media (min-width: 766px) {
      width: 100%;
    }
  }
  
  button:nth-child(1) {
    width: auto;
    justify-content: center;
  }

  button:nth-child(2) {
    width: 123px;
    justify-content: center;
  }

  @media (max-width: 766px) {
    flex-direction: column;
    gap: 16px;
    button {
      min-width: 100%;
      margin-top: 0;
    }
  }
`;

export const CustomDivider = styled(Divider)`
margin-top: 16px;
margin-bottom: 21px;
  border-color: #D6D0CC;
`

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: 24px;
  padding-block-end: 24px;

  > div:nth-of-type(2) {
    margin-block-end: 20px;

    button {
      height: fit-content;
    }

    @media (max-width: 766px) {
      margin-block-end: 0;
    }
  }

  ${CardListActions} button {
    margin-top: 12px;
    width: 100%;
    justify-content: space-between;

    > div:first-of-type {
      padding-left: 0;

      svg {
        fill: ${ids.color.action.secondary.ids_color_action_secondary_base};
        width: 24px;
        height: 24px;
      }
    }

    > div:nth-of-type(2) {
      margin-left: 0;
    }

    @media (min-width: 766px) {
      width: fit-content;
      align-self: end;
    }
  }
`;

export const CardWrapper = styled.div`
  width: 100%;

  > div {
    width: 100%;
    display: block;
    padding: 0;
    max-height: none;

    @media (min-width: 1366px) {
      display: grid;
      grid-template-columns: 390px 1fr;
      height: 312px;
      overflow: hidden;
    }
  }

  img {
    height: 192px;
    width: 100%;
    object-fit: cover;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    @media (min-width: 1366px) {
      height: 100%;
      width: 390px;
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
      border-top-right-radius: 0;
    }
  }
`;

export const CardSupport = styled.div<{ showCopiedFeedback?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div:last-of-type {
    display: flex;
    gap: 24px;

    > button,
    > div > button {
      flex-direction: row-reverse;
      padding: 0;

      @media screen and (width < 768px) {
        > span {
          display: none;
        }
      }
    }

    ${({ showCopiedFeedback }) =>
      showCopiedFeedback &&
      css`
        > button:first-of-type {
          svg path {
            fill: ${ids.color.feedbacks.ids_color_feedback_success} !important;
          }
          > span {
            color: ${ids.color.feedbacks.ids_color_feedback_success};
          }
        }
      `}

    ${({ showCopiedFeedback }) =>
      showCopiedFeedback &&
      css`
        @media screen and (width < 768px) {
          > button:first-of-type > span {
            display: inline-block;
          }
        }
      `}
  }
`;

export const CardInformative = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-block: 20px;
`;

export const ListItemModifier = styled.div`
  > div,
  > button {
    width: 100%;
    height: fit-content;
  }

  > button > div:first-of-type,
  > div > div:first-of-type {
    margin-left: 0;
  }
  > div > div:first-of-type {
    margin-bottom: 20px;
  }
`;

export const TagWrapper = styled.div`
  width: auto;
  height: auto;
  display: flex;
  justify-content: space-between;
`


export const TagLayout = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
`
